import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postProperty,
  putProperty,
  inactivateProperty,
  postPropertyPlot,
  putPropertyPlot,
  deletePropertyPlot,
  postPropertyMap,
  putPropertyMap,
  deletePropertyMap,
  postHarvest,
  putHarvest,
  deleteHarvest,
  setCurrentPropertyDefault
} from '@galo-monitor/services/apis/galoMonitorApi/resources/property'

import { PropertyActions, PropertyTypes } from './duckProperty'

function* saveProperty({ property, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(
      property.id ? putProperty : postProperty,
      property
    )
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* removeProperty({ property, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(inactivateProperty, property)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* setDefaultProperty({ property, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(setCurrentPropertyDefault, property)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* savePropertyPlot({ plot, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(plot.id ? putPropertyPlot : postPropertyPlot, plot)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* removePropertyPlot({ plot, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deletePropertyPlot, plot)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* savePropertyMap({ map, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(map.id ? putPropertyMap : postPropertyMap, map)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* removePropertyMap({ map, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deletePropertyMap, map)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}


function* saveHarvest({ harvest, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(harvest.id ? putHarvest : postHarvest, harvest)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

function* removeHarvest({ harvest, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteHarvest, harvest)
    yield call(onSuccess)
  } catch (err) {
    yield put(PropertyActions.propertyError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(PropertyTypes.SAVE_PROPERTY, saveProperty),
  takeLatest(PropertyTypes.REMOVE_PROPERTY, removeProperty),
  takeLatest(PropertyTypes.SAVE_PROPERTY_PLOT, savePropertyPlot),
  takeLatest(PropertyTypes.REMOVE_PROPERTY_PLOT, removePropertyPlot),
  takeLatest(PropertyTypes.SAVE_PROPERTY_MAP, savePropertyMap),
  takeLatest(PropertyTypes.REMOVE_PROPERTY_MAP, removePropertyMap),
  takeLatest(PropertyTypes.SAVE_HARVEST, saveHarvest),
  takeLatest(PropertyTypes.REMOVE_HARVEST, removeHarvest),
  takeLatest(PropertyTypes.SET_DEFAULT_PROPERTY, setDefaultProperty)
]
